// API service functions for blood test application

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3004';
import axios from 'axios';
import logger from '../utils/logger';

// Configure axios to include credentials (cookies) with all requests
axios.defaults.withCredentials = true;

export const uploadPDF = async (file) => {
  const formData = new FormData();
  formData.append('pdfFile', file);

  const response = await fetch(`${API_BASE_URL}/api/upload`, {
    method: 'POST',
    body: formData,
    credentials: 'include' // Include cookies for auth
  });

  if (!response.ok) {
    throw new Error('Failed to upload PDF');
  }

  return response.json();
};

// export const fetchPatients = async () => {
//     console.log('Fetching patients from:', `${API_BASE_URL}/api/patients`);
//     const response = await axios.get(`${API_BASE_URL}/api/patients`);
  
//   if (!response.ok) {
//     throw new Error('Failed to fetch patients');
//   }

//   return response.data();
// };

 export const fetchPatients = async () => {
    logger.log('Fetching patients from:', `${API_BASE_URL}/api/patients`);
    const response = await axios.get(`${API_BASE_URL}/api/patients`);
    return response.data;
  };

export const fetchPatientById = async (patientId) => {
  const response = await fetch(`${API_BASE_URL}/api/patients/${patientId}`, {
    credentials: 'include' // Include cookies for auth
  });

  if (!response.ok) {
    throw new Error('Failed to fetch patient');
  }

  return response.json();
};

export const fetchBloodTests = async (patientId) => {
  const response = await fetch(`${API_BASE_URL}/api/patients/${patientId}/blood-tests`, {
    credentials: 'include' // Include cookies for auth
  });

  if (!response.ok) {
    throw new Error('Failed to fetch blood tests');
  }

  return response.json();
};


 export const fetchAvailableTests = async (patientId) => {
    const response = await axios.get(`${API_BASE_URL}/api/tests/names/${patientId}`);
    return response.data;
  };



export const fetchTestResults = async (patientId, testName) => {
  const response = await fetch(
    `${API_BASE_URL}/api/patients/${patientId}/test-results?testName=${encodeURIComponent(testName)}`,
    {
      credentials: 'include' // Include cookies for auth
    }
  );

  if (!response.ok) {
    throw new Error('Failed to fetch test results');
  }

  return response.json();
};

export const fetchChartData = async (patientId, testName) => {
  const response = await fetch(
    `${API_BASE_URL}/api/tests/chart/${patientId}/${encodeURIComponent(testName)}`,
    {
      credentials: 'include' // Include cookies for auth
    }
  );

  if (!response.ok) {
    throw new Error('Failed to fetch chart data');
  }

  return response.json();
};

export const deleteBloodTest = async (bloodTestId) => {
  const response = await fetch(`${API_BASE_URL}/api/blood-tests/${bloodTestId}`, {
    method: 'DELETE',
    credentials: 'include' // Include cookies for auth
  });

  if (!response.ok) {
    throw new Error('Failed to delete blood test');
  }

  return response.json();
};

// API object for use with context
export const api = {
  get: async (endpoint) => {
    const response = await axios.get(`${API_BASE_URL}${endpoint}`);
    return response.data;
  },
  post: async (endpoint, data) => {
    const response = await axios.post(`${API_BASE_URL}${endpoint}`, data);
    return response.data;
  },
  put: async (endpoint, data) => {
    const response = await axios.put(`${API_BASE_URL}${endpoint}`, data);
    return response.data;
  },
  delete: async (endpoint) => {
    const response = await axios.delete(`${API_BASE_URL}${endpoint}`);
    return response.data;
  }
};